import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolChiclet from 'ai-components-ui-library/components/chiclets/ToolChiclet';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ToolsList({
  tools
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.functionalityCard.tabs.tools.description"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      children: tools.map(tool => /*#__PURE__*/_jsx("div", {
        style: {
          width: 'fit-content'
        },
        children: /*#__PURE__*/_jsx(ToolChiclet, {
          text: tool.name,
          onClick: () => {},
          "data-test-id": tool.name
        })
      }, tool.name))
    })]
  });
}